import cleanupExpiredBookingSession from './cleanupExpiredBookingSession';
import { FiUser, FiCalendar, FiClock, FiFileText, FiCreditCard, FiArrowLeft } from 'react-icons/fi';
import {useEffect, useState} from "react";
import {addDeposit, addPatientHealthInfo, addPatientInformation, getRoles} from '../../api/routes';
import parse from 'html-react-parser';
import {toast} from 'react-toastify';
import moment from "jalali-moment";
import {updateTab} from "../../features/tab/tabSlice";
import {useDispatch} from "react-redux";
import {Backdrop, CircularProgress} from "@mui/material";
import seperate from "./seperate";

export default function PatientReview() {
    const m = moment();
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    const [paymentToken, setPaymentToken] = useState();
    const closeLoading = () => {
        setLoading(false);
    };
    const openLoading = () => {
        setLoading(true);
    };
    const [roles, setRoles] = useState([])
    const [patientId, setPatientId] = useState();

    useEffect(() => {
        getRoles((isOk, data) => {
            if (!isOk) return toast.error(data.message);
            else return setRoles(data);
        })
    }, [])

    useEffect(() => {
        if (patientId) {
            openLoading()
            const data = {
                patientId
            }
            addDeposit(data, (isOk, data) => {
                if (!isOk) {
                    closeLoading()
                    return toast.error(data.message);
                } else {
                    closeLoading()
                    setPaymentToken(data.token);
                }
            })
        }
    }, [patientId])
    useEffect(() => {
        if (paymentToken)
            document.getElementById("redirect_to_melli").submit()

    }, [paymentToken]);
    const nextLevel = () => {
        if (sessionStorage.getItem('userInformation') !== null && !patientId) {
            openLoading();
            const data = JSON.parse(sessionStorage.getItem('userInformation') || '')?.value
            const image = JSON.parse(sessionStorage.getItem('image') || 'null');
            const prescriptionImage = image && new Date(image.expiredAt) > new Date() ? image.value : undefined;
            if ([32, 46].includes(Number(data?.mainInsuranceId)) && !prescriptionImage) {
                closeLoading();
                toast.error('تصویر نسخه در مراحل قبل ذخیره نشده یا منقضی شده است. لطفاً به مرحله اطلاعات بیمار برگردید و تصویر را دوباره انتخاب کنید.');
                dispatch(updateTab(2));
                return;
            }
            addPatientInformation({ ...data, prescriptionImage }, (isOk, submitedPatient) => {
                if (!isOk) {
                    closeLoading()
                    return toast.error(submitedPatient.message ?? submitedPatient);
                } else {
                        if (sessionStorage.getItem('healthInformation') !== null) {
                            const healthInformationData = JSON.parse(sessionStorage.getItem('healthInformation') || '')?.value
                            addPatientHealthInfo({
                                healthInformationData,
                                patientId: submitedPatient[0].patientId
                            }, (isOk, data) => {
                                if (!isOk) {
                                    closeLoading()
                                    return toast.error(data.message);
                                } else {
                                    setPatientId(submitedPatient[0].patientId);
                                    closeLoading();
                                }
                            })
                        } else {
                            setPatientId(submitedPatient[0].patientId);
                            closeLoading();
                        }
                }
            })
        } else if (patientId) {
            openLoading()
            const data = {
                patientId
            }
            addDeposit(data, (isOk, data) => {
                if (!isOk) {
                    closeLoading()
                    return toast.error(data.message);
                } else {
                    closeLoading()
                    setPaymentToken(data.token);
                }
            })
        }
    }

    useEffect(() => { if (!cleanupExpiredBookingSession()) dispatch(updateTab(0)); }, [dispatch])
    /*  */
    return (
        <div>
            <div className="booking-review booking-review-refined">
                <div className="booking-review-item">
                    <div className="booking-review-icon"><FiUser aria-hidden="true" /></div>
                    <div className="booking-review-copy"><p>نام بیمار</p><strong>{JSON.parse(sessionStorage.getItem('fullname') || 'null')?.value}</strong></div>
                </div>
                <div className="booking-review-item">
                    <div className="booking-review-icon"><FiFileText aria-hidden="true" /></div>
                    <div className="booking-review-copy"><p>خدمت انتخاب‌شده</p><strong>{JSON.parse(sessionStorage.getItem('service') || 'null')?.value}</strong></div>
                </div>
                <div className="booking-review-item">
                    <div className="booking-review-icon"><FiCalendar aria-hidden="true" /></div>
                    <div className="booking-review-copy"><p>تاریخ نوبت</p><strong><bdi>{JSON.parse(sessionStorage.getItem('date') || 'null')?.value}</bdi></strong></div>
                </div>
                <div className="booking-review-item">
                    <div className="booking-review-icon"><FiClock aria-hidden="true" /></div>
                    <div className="booking-review-copy"><p>زمان تقریبی نوبت</p><strong><bdi>{JSON.parse(sessionStorage.getItem('time') || 'null')?.value}</bdi></strong></div>
                </div>
                <div className="booking-review-item booking-price">
                    <div className="booking-review-icon"><FiCreditCard aria-hidden="true" /></div>
                    <p>مبلغ قابل پرداخت</p>
                    <div className="booking-price-value"><strong>{seperate(JSON.parse(sessionStorage.getItem('price') || 'null')?.value)}</strong><small>تومان</small></div>
                </div>
            </div>
            <section className="booking-payment-notes">
                {(roles.length > 0 && roles[0]?.DescriptionVerify) && parse(roles[0]?.DescriptionVerify)}
            </section>

            <section className="booking-actions">
                <button type="button" disabled={loading} onClick={() => !loading && nextLevel()}
                        className='focus:outline-none text-white  bg-[#4b9afe] hover:bg-blue-600 focus:ring-blue-300 focus:ring-4 font-medium rounded-lg px-6 py-2.5'>پرداخت <FiArrowLeft aria-hidden="true" />
                </button>
            </section>
            <Backdrop
                sx={{color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1}}
                open={loading}
            >
                <CircularProgress color="inherit"/>
            </Backdrop>
            <form id="redirect_to_melli" method="get" action="https://sadad.shaparak.ir/VPG/Purchase"
                  style={{display: 'none'}}>
                <input type="hidden" name="Token" value={paymentToken}/>
                <input type="submit" value="Pay"/>
            </form>

        </div>
    )
}
